<template>
    <div class="home-container">
        <nav-list :clickIndex="clickIndex"></nav-list>
        <div class="top-select">
            <div class="date-picker">
                <el-date-picker v-model="selectDate2" type="monthrange" range-separator="至" start-placeholder="开始月份"
                    end-placeholder="结束月份" value-format="yyyy-MM" @change="getMonList" :picker-options="pickerOptions2">
                </el-date-picker>
            </div>
            <div>
                <el-cascader clearable v-model="cityValue" :options="flattenedOptions" :show-all-levels="false"
                    :props="cityProps" @change="cityChange">
                </el-cascader>
            </div>
        </div>
        <div class="chart-two">
            <!-- <div class="line-chart">
                <div class="date-picker1" style="width: 50%;">
                    <el-date-picker v-model="selectDate" type="monthrange" range-separator="至" start-placeholder="开始月份"
                        end-placeholder="结束月份" value-format="yyyy-MM" @change="getuseractivedata"
                        :picker-options="pickerOptions">
                    </el-date-picker>
                </div>
                <div id="dayActive" v-loading="loading" element-loading-text="加载中..."
                    element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.1)"
                    style="width: 100%;height: 100%;"></div>
            </div> -->
            <div class="line-chart">
                <div id="monActive" v-loading="loading2" element-loading-text="加载中..."
                    element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.1)"
                    style="width: 100%;height: 100%;"></div>
            </div>
            <div class="line-chart">
                <el-table :data="tableData" height="calc(100vh - 160px)" row-key="id"
                    :tree-props="{ children: 'children', hasChildren: 'hasChildren' }" default-expand-all border v-loading="tableLoading">
                    <el-table-column prop="name" label="地区" width="160">
                        <template slot-scope="scope">
                            {{ scope.row.name }}
                        </template>
                    </el-table-column>
                    <el-table-column v-for="date in dateColumns" :key="date" :label="date" :prop="date"
                        align="center">
                    </el-table-column>
                </el-table>
            </div>
        </div>
    </div>
</template>
<script>
import {
    getScreenIndex,
    getUserData,
    getKaihuMonthList,
    getKaihuMonthCityList,
    getCityList,
    getCityDataNew
} from "@/api/homeIndex/homeIndex";
import navList from "@/components/navList/navList.vue";

import {
    getDayActiveList,
    getMonActiveList
} from "@/api/inviteIndex/inviteIndex";
import "echarts/extension/bmap/bmap";
export default {
    name: "homeIndex",
    components: {
        navList
    },
    data() {
        return {
            originalData: [],
            tableData: [],
            dateColumns: [],
            currentTime: '',
            tableLoading: true,
            cityProps: {
                value: 'name',
                label: 'name',
                children: 'cities',
                checkStrictly: true
            },
            cityValue: ['安徽省', '合肥市'],
            selectDate: [],
            selectedRange: '',
            timeOptionRange: null,
            // 日期时间范围在一个月以内
            pickerOptions: {
                onPick: ({ maxDate, minDate }) => {
                    // 将选中的起始月份存储在selectDate中
                    this.selectedRange = minDate ? minDate.getTime() : "";

                    if (minDate && !maxDate) {
                        // 记录第一次选择的日期
                        this.timeOptionRange = minDate;
                    }

                    if (maxDate) {
                        // 当两个日期都选择后，重置状态
                        this.selectedRange = "";
                        this.timeOptionRange = null;
                    }
                },
                disabledDate: (time) => {
                    // 新增限制：2024年12月之前的所有日期都禁用
                    const limitDate = new Date(2024, 11, 1); // 2024年12月1日
                    if (time.getTime() < limitDate.getTime()) {
                        return true; // 禁用2024年12月之前的日期
                    }
                    if (this.timeOptionRange) {
                        // 计算12个月范围
                        const start = this.timeOptionRange;
                        const end = new Date(start);
                        end.setMonth(start.getMonth() + 11);

                        // 只允许选择起始月份和结束月份
                        return time.getTime() !== start.getTime() &&
                            time.getTime() !== end.getTime();
                    }
                    return false;
                }
            },

            selectDate2: [],
            selectedRange2: '',
            timeOptionRange2: null,
            // 日期时间范围在一个月以内
            pickerOptions2: {
                onPick: ({ maxDate, minDate }) => {
                    // 将选中的起始月份存储在selectDate中
                    this.selectedRange2 = minDate ? minDate.getTime() : "";

                    if (minDate && !maxDate) {
                        // 记录第一次选择的日期
                        this.timeOptionRange2 = minDate;
                    }

                    if (maxDate) {
                        // 当两个日期都选择后，重置状态
                        this.selectedRange2 = "";
                        this.timeOptionRange2 = null;
                    }
                },
                disabledDate: (time) => {
                    // 限制2024年12月之前的月份
                    const limitDate = new Date(2024, 11, 1); // 2024年12月1日
                    if (time.getTime() < limitDate.getTime()) {
                        return true;
                    }
                    if (this.timeOptionRange2) {
                        // 计算12个月范围
                        const start = this.timeOptionRange2;
                        const end = new Date(start);
                        end.setMonth(start.getMonth() + 11);

                        // 只允许选择起始月份和结束月份
                        return time.getTime() !== start.getTime() &&
                            time.getTime() !== end.getTime();
                    }
                    return false;
                }
            },
            clickIndex: 3,

            indexObj: {},
            pickerTime: "",
            loading: true,
            loading2: true,
            topData: [],
            dataType: "",
            scrollView: false,
            lineOpiton: {
                title: {
                    text: "",
                },
                tooltip: {
                    trigger: "axis",
                },
                legend: {
                    data: ["预约量", "完成量"],
                    textStyle: {
                        color: "#fff",
                    },
                    left: "3%"
                },
                grid: {
                    left: "3%",
                    right: "4%",
                    bottom: "3%",
                    containLabel: true,
                },

                xAxis: {
                    type: "category",
                    boundaryGap: false,
                    data: [],
                    axisLabel: {
                        textStyle: {
                            color: "#fff",
                        },
                    },
                },
                yAxis: {
                    type: "value",
                    axisLabel: {
                        textStyle: {
                            color: "#fff",
                        },
                    },
                },
                series: [
                    {
                        name: "预约量",
                        type: "line",
                        stack: "yuyue",
                        data: [],
                    },
                    {
                        name: "完成量",
                        type: "line",
                        stack: "deal",
                        data: [],
                    }
                ],
            },

            lineOpiton2: {
                title: {
                    text: "",
                },
                tooltip: {
                    trigger: "axis",
                },
                legend: {
                    data: ["开户数", "日均开户数"],
                    textStyle: {
                        color: "#fff",
                    },
                    left: "3%"
                },
                grid: {
                    left: "3%",
                    right: "4%",
                    bottom: "3%",
                    containLabel: true,
                },

                xAxis: {
                    type: "category",
                    boundaryGap: false,
                    data: [],
                    axisLabel: {
                        textStyle: {
                            color: "#fff",
                        },
                    },
                },
                yAxis: {
                    type: "value",
                    axisLabel: {
                        textStyle: {
                            color: "#fff",
                        },
                    },
                },
                series: [
                    {
                        name: "开户数",
                        type: "line",
                        stack: "yuyue",
                        lineStyle: {
                            color: "#0888FF",
                        },
                        itemStyle: {
                            color: "#0888FF",
                        },
                        data: [],
                    },
                    {
                        name: "日均开户数",
                        type: "line",
                        stack: "deal",
                        lineStyle: {
                            color: "#D8B100",
                        },
                        itemStyle: {
                            color: "#D8B100",
                        },
                        data: [],
                    }
                ],
            },

            regionData: [],

            
            
        };
    },
    computed: {
        flattenedOptions() {
            return this.regionData.map(province => {
                // 深拷贝第一级
                const provinceClone = { ...province };

                // 处理第二级：移除第三级children
                if (provinceClone.cities) {
                    provinceClone.cities = provinceClone.cities.map(city => ({
                        id: city.id,
                        name: city.name
                        // 不保留children属性，第三级自动隐藏
                    }));
                }

                return provinceClone;
            });
        },
        // 获取所有不重复的月份
        uniqueMonths() {
            const months = [...new Set(this.rawData.map(item => item.date))];
            return months.sort();
        },
    },
    watch: {},
    created() {
        let startDate = this.$moment().format("YYYY-MM");
        let monDate = this.$moment().subtract(11, "months").format("YYYY-MM");
        this.selectDate = [monDate, startDate];
        this.selectDate2 = [monDate, startDate];
        this.getCityListData()
    },
    mounted() {
        this.$nextTick(() => {
            this.getuseractivedata();
            this.getMonList();
            
        });
        this.getCityTable()
    },

    props: [],
    methods: {
        getCityListData() {
            getCityList().then(res => {
                if (res.data.code == 1) {
                    this.regionData = res.data.data
                }
            })
        },

        cityChange(e) {
            console.log(e)
            this.cityValue = e
            this.getMonList()
        },

        // 获取对于时间范围用户活跃数据
        getuseractivedata(e = null) {
            console.log(e, '选择年份');
            this.loading = true
            if (!e)
                var obj = {
                    start_date: this.selectDate[0],
                    end_date: this.selectDate[1],
                };
            else
                var obj = {
                    start_date: e[0],
                    end_date: e[1],
                };
            getKaihuMonthList(obj).then((res) => {
                this.loading = false
                console.log(res);
                let xData = [];
                let deal = [];
                let yuyue = [];
                res.data.data.forEach((val) => {
                    xData.push(val.date);
                    deal.push(val.deal);
                    yuyue.push(val.yuyue);

                });
                this.lineOpiton.xAxis.data = xData;
                this.lineOpiton.series[0].data = yuyue;
                this.lineOpiton.series[1].data = deal;
                this.$echarts
                    .init(document.getElementById("dayActive"))
                    .setOption(this.lineOpiton);
            });
        },

        // 获取对于时间范围用户活跃数据
        getMonList(e = null) {
            this.loading2 = true
            console.log(e, 'getMonList');
            console.log(this.selectDate2, 'selectDate2')
            if (!e)
                var obj = {
                    start_date: this.selectDate2[0],
                    end_date: this.selectDate2[1],
                    province: this.cityValue[0],
                    city: this.cityValue[1]
                };
            else
                var obj = {
                    start_date: e[0],
                    end_date: e[1],
                    province: this.cityValue[0],
                    city: this.cityValue[1]
                };
            getKaihuMonthCityList(obj).then((res) => {
                this.loading2 = false
                let xData = [];
                let yuyue = []
                let day_yuyue = []
                res.data.data.forEach(val => {
                    xData.push(val.date);
                    yuyue.push(val.yuyue)
                    day_yuyue.push(val.day_yuyue)
                })
                this.lineOpiton2.xAxis.data = xData;
                this.lineOpiton2.series[0].data = yuyue;
                this.lineOpiton2.series[1].data = day_yuyue;
                this.$echarts
                    .init(document.getElementById("monActive"))
                    .setOption(this.lineOpiton2);
            });
            this.getCityTable()
        },

        getCityTable() {
            var obj = {
                start_date: this.selectDate2[0],
                end_date: this.selectDate2[1],
                province: this.cityValue[0],
                city: this.cityValue[1]
            };
            getCityDataNew(obj).then(res => {
                console.log(res)
                this.originalData = res.data.data
                this.processData()
            })
        },
        
         // 处理原始数据，转换为树形表格所需格式
        processData() {
            // 获取所有日期列
            const dates = [...new Set(this.originalData.map(item => item.date))].sort();
            this.dateColumns = dates;

            // 按省份分组
            const provinceMap = {};

            // 首先创建省份节点
            this.originalData.forEach(item => {
                const province = item.province;
                if (!provinceMap[province]) {
                    provinceMap[province] = {
                        id: province,
                        name: province,
                        type: 'province',
                        children: [],
                        // hasChildren: true
                    };

                    // 初始化每个日期列的值为0
                    dates.forEach(date => {
                        provinceMap[province][date] = 0;
                    });
                }
            });

            // 然后处理每个日期的数据
            this.originalData.forEach(item => {
                const province = item.province;

                // 设置省份在当前日期的值
                provinceMap[province][item.date] = item.data;

                // 处理城市数据
                item.citydata.forEach(cityItem => {
                    let city = provinceMap[province].children.find(c => c.name === cityItem.city);
                    if (!city) {
                        city = {
                            id: `${province}-${cityItem.city}`,
                            name: cityItem.city,
                            type: 'city',
                            parentId: province
                        };

                        // 初始化每个日期列的值为0
                        dates.forEach(date => {
                            city[date] = 0;
                        });

                        provinceMap[province].children.push(city);
                    }

                    // 设置城市在当前日期的值
                    city[item.date] = cityItem.data;
                });
            });

            // 转换为数组
            this.tableData = Object.values(provinceMap);

            // 打印调试信息
            console.log("处理后的表格数据:", this.tableData);
            this.tableLoading = false
        }

    },
};
</script>

<style lang="scss">
@import "@/styles/home.scss";
@import "@/styles/common.scss";

.header-cell {
    color: #61d2f7 !important;
    font-size: 14px;
    font-weight: 600;
    height: 48px;
    background-color: #072951 !important;
    box-shadow: -10px 0px 15px #034c6a inset, 10px 0px 15px #034c6a inset;
}

.row-cell {
    color: #fff !important;
    background-color: #072951 !important;
}

.row-cells {
    color: #fff !important;
    background-color: #072951 !important;
    box-shadow: -10px 0px 15px #034c6a inset, 10px 0px 15px #034c6a inset;
}

.chart-two {
    padding-top: 20px;
    width: 100%;
    display: flex;
    justify-content: space-between;

    .line-chart {
        width: 50%;
        height: calc(100vh - 160px) !important;
    }
}

.picker-list {
    display: flex;
    align-items: center;
}
</style>
